import Sidebar from "./BrokerSidebar";

export default function BrokerDashboardLayout({ children }) {
  return (
    <div
      className="
        flex min-h-screen antialiased text-[#1A1A1A]
        bg-gradient-to-br from-white via-[#f6f7f9] to-[#eceff3]
        bg-fixed
      "
    >
      <Sidebar />

      {/* NO padding here */}
      <main className="flex-1 overflow-y-auto md:ml-64">
        {/* SINGLE source of truth for width + padding */}
        <div className="w-full max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8">
          {children}
        </div>
      </main>
    </div>
  );
}

